<template>
  <div>
    <template v-for="pref in items" :key="pref.name">
      <div v-if="pref.is_global" class="callout callout-info mb-3">
        <i class="fa-regular fa-circle-info fa-xl callout-icon" aria-hidden="true"></i>
        <div>
          <div class="callout-title">{{ callout_title }}</div>
          <p class="mb-0" v-html="callout_text"></p>
        </div>
      </div>

      <div class="row" :class="{ 'opacity-50': isDimmed(pref) }">
        <div class="col">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              :id="pref.name"
              v-model="pref.checked"
              :disabled="isDimmed(pref)"
              @change="toggle(pref)"
            >
            <label class="form-check-label" :for="pref.name">
              {{ pref.label }}
            </label>
          </div>
          <div class="w-100 my-1">
            <i v-if="pref.saveInProgress" class="fa-solid fa-spinner fa-spin-pulse fa-spin-reverse"></i>
            <span v-if="pref.saved" class="text-success fw-bold">{{ pref.saved_message_label }}</span>
          </div>
        </div>
      </div>
      <hr v-if="!isLastVisible(pref)">
    </template>
  </div>
</template>

<script>
export default {
  props: [
    'preferences',
    'callout_title',
    'callout_text',
  ],

  data() {
    return {
      items: this.preferences.map((pref) => ({
        ...pref,
        checked: pref.value == 1,
        saved: false,
        saveInProgress: false,
      })),
    };
  },

  computed: {
    globalChecked() {
      const globalItem = this.items.find((item) => item.is_global);
      return globalItem ? globalItem.checked : true;
    },
  },

  methods: {
    isDimmed(pref) {
      return pref.gated_by_global && !pref.is_global && !this.globalChecked;
    },

    isLastVisible(pref) {
      return this.items[this.items.length - 1].name === pref.name;
    },

    toggle(pref) {
      pref.saved = false;
      pref.saveInProgress = true;

      axios.post(pref.post_url, {
        checked: pref.checked,
        property: pref.post.property,
      })
        .then((response) => {
          const data = response.data;
          if (data === true || data === false) {
            pref.checked = data;
            pref.saved = true;
          }
          pref.saveInProgress = false;
        });
    },
  },
}
</script>
